var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlvotechSquareMeter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#F69D25;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F69D25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipline"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "biosimilar"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "employees"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "generic-projects"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing-centers"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "key-growth"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "molecule"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "green"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "map"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "playground"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "microscope"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "hand-pill"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cosmetics"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medical"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "dna_1_"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "investment"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "company"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "square-meter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "neutral_20_",
    className: "st0",
    d: "M165,48v203.8h-40.8V48H42.7v407.7h81.5v-81.5H165v81.5h285.4V48H165z M430,435.2H185.4 v-61.1v-20.4H165h-40.8h-20.4v20.4v61.1H63.1V68.3h40.8v183.4v20.4h20.4H165h20.4v-20.4V68.3H430V435.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color_14_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.4,170.6c0-10.3,5-15.6,13.1-15.6c8.1,0,12.7,5.3,12.7,15.6v42.7h21.7v-42.7c0-10.3,5-15.6,13.1-15.6 c8.1,0,12.7,5.3,12.7,15.6v42.7h21.7v-49.8c0-18.4-9.7-28.1-25.8-28.1c-10.4,0-18.4,4.3-25.1,12.1c-4-7.7-11.6-12.1-21.6-12.1 c-11,0-17.6,5.9-22.5,12.3v-10.9h-21.7v76.5h21.7V170.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.6,154.7h-25.3l9.5-7.3c10.3-8,15.3-12.9,15.3-22.6c0-10.9-7.6-18-20-18c-10.4,0-15.9,4.2-21.7,12l9,7.2 c4.3-5.3,7.4-7.8,11.9-7.8c4.6,0,7.8,2.6,7.8,7.6c0,4.8-2.8,8-10,14l-19.3,15.8v10.2h43V154.7z"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "bios-generics"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "professional"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "capacity"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "award"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "pills"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "people"
  })));
}

export default SvgAlvotechSquareMeter;